import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface AllocateCancelProps {
    cancelDetails: CancelDetails;
    cancelOptions: GenericList[];
    showModal: boolean;
    hideModal(): void;
    updateData(cancelDetails: CancelDetails): void;
    save(): void;
}

interface CancelModal {
    errors: any;
    loading: boolean;
}

interface CancelDetails {
    rowIndex: number;
    id: number;
    itemId: number;
    item: string;
    cancelReasonId: number;
}

interface GenericList {
    id: number;
    name: string;
}

export default class AllocateCancelModal extends React.Component<AllocateCancelProps, CancelModal> {
    constructor(props: AllocateCancelProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        //update props item
        var cancelDetails = this.props.cancelDetails;
        let newDetails: any = cancelDetails;
        newDetails[e.target.name] = e.target.value;

        //update errors
        let change: any = {};
        change["errors"] = errors;
        this.setState(change);

        this.props.updateData(newDetails);
    }

    hideModal = () => {
        this.setState({ errors: {} });
        this.props.hideModal();
    }

    validate = () => {
        let fields = this.props.cancelDetails;
        let errors: any = {};
        let formIsValid = true;

        if (fields.cancelReasonId <= 0) {
            formIsValid = false;
            errors["cancelReasonId"] = "Reason is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let cancelDetails = this.props.cancelDetails;
        let cancelOptions = this.props.cancelOptions;

        return (
            <div className="static-modal">
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Cancel {cancelDetails.item}</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <label className="input-group" htmlFor="cancelReasonId">
                                <span className="label">Reason</span>
                                <select className="select" id="cancelReasonId" name="cancelReasonId" value={cancelDetails.cancelReasonId} onChange={(e) => this.handleChange(e)} >
                                    <option defaultValue="-1"></option>
                                    {cancelOptions.map(reason =>
                                        <option key={reason.id} value={reason.id}>{reason.name}</option>
                                    )}
                                </select>
                            </label>
                            <span className="label errors">{this.state.errors["cancelReasonId"]}</span>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }



}